<template>
  <div class="list" name="info">
    <el-card class="searchCard" shadow="never">
      <el-col>
        <el-form :inline="true" :model="searchForm">
          <el-form-item label="绑定时间">
            <date-range-picker
              :value="comeTime"
              @getChange="dateChange"
              disabledBeforeDate='-1'>
            </date-range-picker>
          </el-form-item>
          <el-form-item label="乐刷商户号">
            <el-input class="search-imput" v-model="searchForm.merchantId" clearable></el-input>
          </el-form-item>
          <el-form-item label="直属代理商编号">
            <el-input class="search-imput" v-model="searchForm.agentId" clearable></el-input>
          </el-form-item>
          <el-form-item label="设备SN">
            <el-input class="search-imput" v-model="searchForm.deviceSN" clearable></el-input>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="search"
              :plain="true"
              icon="el-icon-search"
              @click.native="buttonSearch"
              :loading="searchLoading"
              label="查询"></auth-button>
          </el-form-item>
          <el-form-item>
            <auth-button
              opt="add"
              @click.native="handleAdd"
              label="新增"></auth-button>
          </el-form-item>
        </el-form>
      </el-col>
    </el-card>
    <el-card class="tableCard" shadow="never">
      <el-table
        stripe
        style="width:100%"
        align="center"
        v-loading="searchLoading"
        :data="list"
        :header-cell-style="{background:'#FAFAFA'}"
      >
        <el-table-column
          prop="merchantId"
          label="乐刷商户号"
          align="center">
        </el-table-column>
        <el-table-column
          prop="pId"
          label="支付宝PID"
          align="center">
        </el-table-column>
        <el-table-column
          prop="shopId"
          label="门店ID"
          align="center">
        </el-table-column>
        <el-table-column
          prop="deviceSn"
          label="设备SN"
          align="center">
        </el-table-column>
        <el-table-column
          prop="status"
          label="状态"
          align="center">
          <template slot-scope="scope">
            <span>{{ renderStatus(scope.row.status) }}</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="agentId"
          label="直属代理商"
          align="center">
        </el-table-column>
        <el-table-column
          prop="bindTimeStr"
          label="绑定时间"
          align="center">
        </el-table-column>
        <el-table-column
          prop="action"
          label="操作"
          align="center">
          <template slot-scope="scope">
            <auth-button
              opt="bind"
              type="text"
              v-if="scope.row.status===0"
              @click.native="handleBind(scope.row.deviceSn)"
              label="绑定"></auth-button>
            <auth-button
              opt="unBind"
              type="text"
              v-else
              @click.native="handleUnbind(scope.row)"
              label="解绑"></auth-button>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-col :span="24" class="btm-action">
      <el-pagination
        class="pagination"
        v-if="paginations.total>0"
        :page-sizes="paginations.pageSizes"
        :page-size="paginations.pageSize"
        :layout="paginations.layout"
        :total="paginations.total"
        :pageNum="paginations.pageNum"
        @current-change="onChangeCurrentPage">
      </el-pagination>
    </el-col>
    <el-dialog
      :title="isAdd?'新增':'绑定'"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
      :close-on-click-modal="false"
      @close="$refs['bindForm'].resetFields()">
      <el-form :model="bindForm" label-width="100px" label-position="left" ref="bindForm" :rules="formRules">
          <el-form-item label="乐刷商户号" prop="merchantId">
            <el-input class="form-input" v-model="bindForm.merchantId" @blur="queryShopId"></el-input>
          </el-form-item>
          <el-form-item label="门店ID" prop="shopId">
            <el-select class="form-input" v-model="bindForm.shopId" @change="queryShopInfo">
              <el-option v-for="shopId in shopIdList" :key="shopId" :label="shopId" :value="shopId"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="支付宝PID" prop="merchantPId">
            <el-input class="form-input" v-model="bindForm.merchantPId" disabled></el-input>
          </el-form-item>
          <el-form-item label="设备SN" prop="deviceSN">
            <el-input class="form-input" v-model="bindForm.deviceSN" :disabled="!isAdd"></el-input>
          </el-form-item>
        </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" :loading="submitLoading" @click="handleSubmit" style="align:center">{{isAdd?'确定提交':'保存'}}</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import qs from 'qs'
import dateRangePicker from '@/components/dateRangePicker'
import { listRuyiMachine, queryShopId, queryShopInfo, ruyiMachineBind, ruyiMachineUnbind } from '@/api/machine'
export default {
  components: {
    dateRangePicker
  },
  data () {
    return {
      comeTime: [],
      searchForm: {
        bindTimeEnd: '',
        bindTimeStart: '',
        merchantId: '',
        agentId: '',
        deviceSN: '',
        status: '',
        pageSize: 10
      },
      bindForm: {
        merchantId: '',
        merchantPId: '',
        smId: '',
        shopId: '',
        deviceSN: ''
      },
      searchLoading: false,
      submitLoading: false,
      dialogVisible: false,
      isAdd: false,
      formRules: {
        merchantId: [{
          required: true,
          message: '请选择乐刷商户号'
        }],
        merchantPId: [{
          required: true,
          message: '请选择支付宝PID'
        }],
        shopId: [{
          required: true,
          message: '请选择门店ID'
        }],
        deviceSN: [{
          required: true,
          message: '请输入设备SN'
        }]
      },
      // 需要给分页组件传的信息
      paginations: {
        pageNum: 1,
        total: 0,
        pageSize: 10,
        pageSizes: [10],
        layout: 'total, prev, pager, next, jumper'
      },
      statusList: [
        {
          text: '未绑定',
          value: 0
        }, {
          text: '已绑定',
          value: 10
        }
      ],
      shopIdList: []
    }
  },
  mounted () {
    this.setDefaultDate()
    this.getList()
  },
  methods: {
    /**
         * @description 初始日期选择
         */
    setDefaultDate () {
      let end = new Date()
      let start = new Date()
      start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
      start = start.getFullYear() + '-' + (((start.getMonth() + 1) < 10) ? ('0' + (start.getMonth() + 1)) : (start.getMonth() + 1)) + '-' + ((start.getDate() < 10) ? ('0' + start.getDate()) : (start.getDate())) + ' 00:00:00'
      end = end.getFullYear() + '-' + (((end.getMonth() + 1) < 10) ? ('0' + (end.getMonth() + 1)) : (end.getMonth() + 1)) + '-' + ((end.getDate() < 10) ? ('0' + end.getDate()) : (end.getDate())) + ' 23:59:59'
      this.comeTime = [start, end]
      // this.dateChange(this.comeTime)
    },
    getList () {
      if (this.comeTime) {
        [this.searchForm.bindTimeStart, this.searchForm.bindTimeEnd] = this.comeTime
      }
      const startDate = new Date(this.searchForm.bindTimeStart)
      const endDate = new Date(this.searchForm.bindTimeEnd)
      if (!this.searchForm.bindTimeStart || !this.searchForm.bindTimeEnd || endDate.getTime() - startDate.getTime() > 3600 * 1000 * 24 * 31 - 1) {
        this.$message({
          message: '请筛选1个月内的数据进行查询',
          type: 'error'
        })
        this.searchLoading = false
        return
      }
      this.searchLoading = true
      var data = this.formatSearch(this.searchForm)
      data = qs.stringify(data)
      listRuyiMachine(data).then((res) => {
        this.searchLoading = false
        if (parseInt(res.error_code) !== 0) {
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
          this.searchLoading = false
        } else {
          this.paginations.total = res.totalCount
          this.list = res.list
        }
      })
    },
    dateChange (value) {
      this.comeTime = value
    },
    /**
     * 改变当前页事件
     * @param  {number} page 当前页码
     */
    onChangeCurrentPage (page) {
      var totalCount = this.machinesNum
      this.searchForm.pageNo = page
      this.searchForm.Count = totalCount
      this.getList()
    },
    buttonSearch () {
      // 当点击查询时，显示第一页
      this.searchForm.pageNo = 1
      // 让页码数回归到1
      this.paginations.total = 0
      this.onSearch()
    },
    handleAdd () {
      this.isAdd = true
      this.dialogVisible = true
    },
    handleBind (deviceSN) {
      this.isAdd = false
      this.bindForm.deviceSN = deviceSN
      this.dialogVisible = true
    },
    handleUnbind (row) {
      this.$confirm('是否解除该如意机具绑定？', '提示', {}).then(() => {
        const data = qs.stringify({
          merchantId: row.merchantId,
          merchantPId: row.pId,
          shopId: row.shopId,
          deviceSN: row.deviceSn,
          smId: row.subMerchantId
        })
        ruyiMachineUnbind(data).then((res) => {
          if (parseInt(res.error_code) !== 0) {
            this.$message({
              showClose: true,
              message: res.error_msg,
              type: 'error'
            })
          } else {
            this.$message({
              showClose: true,
              message: '解绑成功',
              type: 'success'
            })
            this.getList()
          }
        })
      })
    },
    formatSearch (search) {
      var data = Object.assign({}, search)
      for (var s in data) {
        if (!data[s] && data[s] !== 0) {
          delete data[s]
        } else {
          data[s] = this.$jquery.trim(data[s])
        }
      }
      return data
    },
    // 点击搜索按钮事件
    onSearch () {
      this.searchLoading = true
      this.searchForm.pageNo = 1
      this.getList()
    },
    queryShopId (e) {
      const data = qs.stringify({ merchantId: e.target.value })
      queryShopId(data).then((res) => {
        if (parseInt(res.error_code) === 0) {
          if (res.data) {
            this.shopIdList = res.data.shopList
          } else {
            this.shopIdList = []
          }
        } else {
          this.shopIdList = []
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        }
      })
    },
    queryShopInfo (shopId) {
      const data = qs.stringify({
        merchantId: this.bindForm.merchantId,
        shopId: shopId
      })
      queryShopInfo(data).then((res) => {
        if (parseInt(res.error_code) === 0) {
          if (res.data) {
            this.bindForm.merchantPId = res.data.merchantPId
            this.bindForm.smId = res.data.subMerchantId
          } else {
            this.bindForm.merchantPId = ''
            this.bindForm.smId = ''
          }
        } else {
          this.bindForm.merchantPId = ''
          this.bindForm.smId = ''
          this.$message({
            showClose: true,
            message: res.error_msg,
            type: 'error'
          })
        }
      })
    },
    handleSubmit () {
      this.submitLoading = true
      this.$refs.bindForm.validate((valid) => {
        if (valid) {
          const data = qs.stringify(this.bindForm)
          ruyiMachineBind(data).then((res) => {
            this.submitLoading = false
            if (parseInt(res.error_code) !== 0) {
              this.$message({
                showClose: true,
                message: res.error_msg,
                type: 'error'
              })
            } else {
              this.$message({
                showClose: true,
                message: '绑定成功',
                type: 'success'
              })
              this.dialogVisible = false
              this.buttonSearch()
            }
          })
        }
      })
    },
    renderStatus (status) {
      const result = this.statusList.filter((item) => {
        return item.value === status
      })
      if (result.length > 0) {
        return result[0].text
      } else {
        return '未知'
      }
    }
  }
}
</script>

<style rel="stylesheet/scss" lang="scss" scoped>
  .btm-action {
    margin-top: 20px;
    text-align: center;
  }
  /deep/ .el-dialog__footer {
    text-align: center;
  }
  .form-input {
    width: 70%;
  }
  /deep/ .el-dialog__body {
    margin-left: 12px;
    padding-bottom: 0;
  }
  .pagination {
    display: inline-block;
  }
</style>
